import React from "react";
import {
  SD_gallery_01,
  SD_gallery_04,
  SD_gallery_02,
  SD_gallery_03,
  SD_gallery_05,
  SD_gallery_06,
  SD_gallery_07,
  SD_gallery_08,
} from "../../Assets/imageList";
import "../../Utils/sd-styles/sd-main-sup.scss";
import ModalImage from "react-modal-image";

import Sd_breadcrumb from "./sd-breadcrumb";
const Sd_gallery_full_view = () => {
  return (
    <>
      <Sd_breadcrumb from="Gallery" />
      <div className="sd-template-five">
        <br />
        <br />
        <h2>Photo Gallery</h2>
        <br></br>
        <div className="sd-photo-grid-full">
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_01}
            large={SD_gallery_01}
            alt="picture1"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_02}
            large={SD_gallery_02}
            alt="picture2"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_03}
            large={SD_gallery_03}
            alt="picture3"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_04}
            large={SD_gallery_04}
            alt="picture4"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_05}
            large={SD_gallery_05}
            alt="picture5"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_06}
            large={SD_gallery_06}
            alt="picture6"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_07}
            large={SD_gallery_07}
            alt="picture7"
          />
          <ModalImage
            className="sd-modal-image"
            small={SD_gallery_08}
            large={SD_gallery_08}
            alt="picture8"
          />
        </div>
      </div>
    </>
  );
};
export default Sd_gallery_full_view;
